import { AttendingEventStatusParams } from "store/attendingEvents/attendingEvents.types";
import { getApi } from "./util/getApi";

const fetchURL = process.env.REACT_APP_API_URL + "/user";

const api = getApi(fetchURL);

export const getUserByUserId = async (id: number) => {
  const res = await api.post("/retrieveDocument", { id });
  return res.data;
};

export const RetrievePublicProfile = async (id: number) => {
  const res = await api.post(`/publicProfile`, { id });
  return res.data;
};
export const getFollowers = async (id: number) => {
  const res = await api.post(`/followInfo`, { id });
  return res.data;
};

export const RetrievePrivateProfile = async (id: number) => {
  const res = await api.post(`/privateProfile`, { id });
  return res.data;
};

export const searchDocuments = async (templateType: string) => {
  try {
    const response = await api.post(`/searchDocuments`, { templateType });
    return response;
  } catch (error) {
    console.error("Error searching documents:", error);
    throw error;
  }
};

export const searchUsersApi = async (searchText: string) => {
  try {
    const response = await api.post(`/searchDocuments`, {
      searchText,
      isFollowing: true,
    });
    return response;
  } catch (error) {
    console.error("Error searching documents:", error);
    throw error;
  }
};

export const toggleIdolApi = async (idolUserId: number) => {
  try {
    const res = await api.post("/toggleIdol", { idolUserId });
    return res.data as { followersCount: number; isIdolized: boolean };
  } catch (err) {
    console.error("Error toggling idol:", err);
    throw err;
  }
};

export const setStatusData = async (params: AttendingEventStatusParams) => {
  try {
    const res = await api.post("/setStatusData", {
      activityId: Number(params.activityId),
      statusType: params.status,
    });
    return res.data;
  } catch (error) {
    console.error("Error setting status data:", error);
    throw error;
  }
};

export const getVolunteers = async () => {
  try {
    const res = await api.get("/volunteerSpotlight");
    return res.data;
  } catch (error) {
    console.error("Error getting volunteers:", error);
    throw error;
  }
};
